import { getOrder } from '../global'

export const redactCCFromOrder = order => {
  const reportOrder = order
  if (reportOrder && reportOrder.paymentInfo) {
    let cc = reportOrder.paymentInfo.filter(payment => payment.paymentType === 'CYBERV3')
    if (cc && cc.length > 0) {
      const newCC = cc[0]
      cc = newCC
      if (cc.paymentProperties && cc.paymentProperties.token) {
        reportOrder.paymentInfo.filter(payment => payment.paymentType === 'CYBERV3')[0].paymentProperties = {}
      }
    }
  }
  return reportOrder
}

/**
 * Takes in the JWT token from order.paymentInfo.paymentProperties.token for a credit card payment
 * and decodes it to return an object containing the expiration date string as MM/YYYY and the masked
 * last 4 digits of the card number as a string (x####)
 * @param {string} token - a JWT token string for a credit card payment
 * @returns object { exp, maskedCardNum }
 */
export const parseJwt = token => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)) // eslint-disable-line
      .join(''),
  )

  let maskedData = JSON.parse(jsonPayload)?.data ?? null

  if (!maskedData) {
    const { card } = JSON.parse(jsonPayload)?.content?.paymentInformation ?? {}
    maskedData = {
      expirationMonth: card?.expirationMonth?.value,
      expirationYear: card?.expirationYear?.value,
      number: card?.number?.maskedValue,
    }
  }

  return {
    maskedCardNum: `x${maskedData.number.slice(-4)}`,
    exp: `${maskedData.expirationMonth}/${maskedData.expirationYear}`,
  }
}

export const getCreditCardDecision = (orderIn = null, includeDetails = false) => {
  let decision = false
  let cardDetails
  const order = orderIn ? { ...orderIn } : getOrder()

  if (order && order.paymentInfo && order.paymentInfo.length > 0) {
    const ccPayment = order.paymentInfo.find(payment => payment.paymentType === 'CYBERV3')
    if (ccPayment && ccPayment.paymentProperties && ccPayment.paymentProperties.token) {
      cardDetails = parseJwt(ccPayment.paymentProperties.token)
      decision = true
    }
  }
  return includeDetails ? { cardDetails, decision } : decision
}

export const scrollTo = element => {
  setTimeout(() => {
    if (document.getElementById(element)) {
      document.getElementById(element).scrollIntoView({
        behavior: 'smooth',
      })
    }
  }, 1000)
}
